<template>
  <div class="csmar-page">
    <!-- 顶部banner -->
    <div class="banner">
      <img src="./../assets/img-mobile/banner.jpg" alt="" />
      <!-- 顶部按钮 -->
      <!-- <div class="btnOptions">
        <div class="securityBtn btn" v-show="showSecurityBtn">
          <svg
            version="1.1"
            id="图层_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 200 200"
            width="14"
            height="13"
            style="enable-background: new 0 0 200 200"
            xml:space="preserve"
            class="securitySvg"
          >
            <path
              d="M125.1,129c0,0-4.6,5.3-11.4,0c-6.8-5.3-30.3-30.5-30.3-30.5s-5.6-6.4-11.9,0c-6.3,6.4-25.8,34.2-25.8,34.2s-6.1,10-14.9,0
                c-7.6-8.6-14.1-4.9-15.8-3.7v37.6c0,6.4,5.4,11.7,12.1,11.7h145.7c6.7,0,12.1-5.2,12.1-11.7l0-102.8c-0.5,0.1-0.9,0.3-1.4,0.5
                L125.1,129z M36.2,115c7.8,0,14.2-6.1,14.2-13.6c0-1.9-0.4-3.8-1.2-5.4L74,66.5c1.4,0.4,2.9,0.7,4.4,0.7c2.1,0,4.1-0.5,5.9-1.3
                l21.7,20.9c-0.5,1.3-0.8,2.7-0.8,4.2c0,7.5,6.3,13.6,14.2,13.6c7.8,0,14.2-6.1,14.2-13.6c0-1.7-0.4-3.3-0.9-4.7l33.8-38
                c1.4,0.4,2.8,0.7,4.3,0.7c7.8,0,14.2-6.1,14.2-13.6s-6.3-13.6-14.2-13.6c-7.8,0-14.2,6.1-14.2,13.6c0,1.7,0.4,3.4,1,4.9l-33.7,37.9
                c-1.4-0.5-2.9-0.8-4.5-0.8c-1.8,0-3.5,0.3-5,0.9L92.1,56.9c0.3-1.1,0.5-2.2,0.5-3.3c0-7.5-6.3-13.6-14.2-13.6s-14.2,6.1-14.2,13.6
                c0,1.7,0.4,3.3,0.9,4.8L40,88.3c-1.2-0.3-2.5-0.6-3.8-0.6c-7.8,0-14.2,6.1-14.2,13.6C22,108.9,28.4,115,36.2,115z"
              fill="#d86327"
            />
          </svg>
          <span class="securityText">证券投资赛道</span>
        </div>
        <div
          class="securityBtn1 btn"
          v-show="!showSecurityBtn"
          @click="showSecurityImg"
        >
          <svg
            version="1.1"
            id="图层_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 200 200"
            width="14"
            height="13"
            style="enable-background: new 0 0 200 200"
            xml:space="preserve"
            class="securitySvg"
          >
            <path
              d="M125.1,129c0,0-4.6,5.3-11.4,0c-6.8-5.3-30.3-30.5-30.3-30.5s-5.6-6.4-11.9,0c-6.3,6.4-25.8,34.2-25.8,34.2s-6.1,10-14.9,0
                c-7.6-8.6-14.1-4.9-15.8-3.7v37.6c0,6.4,5.4,11.7,12.1,11.7h145.7c6.7,0,12.1-5.2,12.1-11.7l0-102.8c-0.5,0.1-0.9,0.3-1.4,0.5
                L125.1,129z M36.2,115c7.8,0,14.2-6.1,14.2-13.6c0-1.9-0.4-3.8-1.2-5.4L74,66.5c1.4,0.4,2.9,0.7,4.4,0.7c2.1,0,4.1-0.5,5.9-1.3
                l21.7,20.9c-0.5,1.3-0.8,2.7-0.8,4.2c0,7.5,6.3,13.6,14.2,13.6c7.8,0,14.2-6.1,14.2-13.6c0-1.7-0.4-3.3-0.9-4.7l33.8-38
                c1.4,0.4,2.8,0.7,4.3,0.7c7.8,0,14.2-6.1,14.2-13.6s-6.3-13.6-14.2-13.6c-7.8,0-14.2,6.1-14.2,13.6c0,1.7,0.4,3.4,1,4.9l-33.7,37.9
                c-1.4-0.5-2.9-0.8-4.5-0.8c-1.8,0-3.5,0.3-5,0.9L92.1,56.9c0.3-1.1,0.5-2.2,0.5-3.3c0-7.5-6.3-13.6-14.2-13.6s-14.2,6.1-14.2,13.6
                c0,1.7,0.4,3.3,0.9,4.8L40,88.3c-1.2-0.3-2.5-0.6-3.8-0.6c-7.8,0-14.2,6.1-14.2,13.6C22,108.9,28.4,115,36.2,115z"
              fill="#8b7f6f"
            />
          </svg>
          <span class="securityText1">证券投资赛道</span>
        </div>
        <div class="quantificatBtn btn" v-show="!showQuantificatBtn">
          <svg
            version="1.1"
            id="图层_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 200 200"
            width="14"
            height="13"
            style="enable-background: new 0 0 200 200"
            xml:space="preserve"
            class="quantificatSvg"
          >
            <path
              d="M72.1,94.3c-5.9-0.2-10.9,4.4-11.1,10.3c-0.2,5.9,4.4,10.9,10.3,11.1c0.3,0,0.5,0,0.8,0c5.9-0.2,10.6-5.2,10.3-11.1
                    C82.3,99,77.7,94.5,72.1,94.3z M168.2,34.3H30.8c-9.2,0.1-16.6,7.7-16.5,16.9c0,0.1,0,0.1,0,0.2v94.3c-0.2,9.2,7.1,16.9,16.3,17.1
                    c0.1,0,0.1,0,0.2,0h43.4l-14.5,10.3c-3.4,3.1-3.8,8.3-1,12c2.4,3.6,7.3,4.5,10.9,2.1c0.2-0.1,0.3-0.2,0.4-0.3L100,165l28.9,21.9
                    c3.4,2.7,8.3,2.1,11-1.3c0.1-0.1,0.2-0.3,0.3-0.4c2.8-3.7,2.4-8.9-1-12l-14.5-10.3h43.4c9.5,0,17.3-7.6,17.6-17.1V51.4
                    C185.4,41.9,177.7,34.3,168.2,34.3L168.2,34.3z M72.1,128.6c-13,0.5-23.9-9.7-24.4-22.7c-0.5-13,9.7-23.9,22.7-24.4
                    s23.9,9.7,24.4,22.7c0,0.3,0,0.5,0,0.8C94.9,117.7,84.8,128.2,72.1,128.6L72.1,128.6z M124.8,120c0.3,4.4-3.1,8.3-7.5,8.6
                    c-0.2,0-0.5,0-0.7,0c-4.6-0.2-8.2-4-8.3-8.6V98.5c0-4.6,3.7-8.4,8.3-8.6c4.4-0.1,8.2,3.4,8.3,7.8c0,0.2,0,0.5,0,0.7V120L124.8,120z
                    M150.6,120c0,4.6-3.7,8.3-8.3,8.3s-8.3-3.7-8.3-8.3V77.1c0-4.6,3.7-8.3,8.3-8.3s8.3,3.7,8.3,8.3V120z"
              fill="#e55240"
            />
          </svg>
          <span class="quantificatText">量化投资赛道</span>
        </div>
        <div class="quantificatBtn1 btn" v-show="showQuantificatBtn">
          <svg
            version="1.1"
            id="图层_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 200 200"
            width="14"
            height="13"
            style="enable-background: new 0 0 200 200"
            xml:space="preserve"
            class="quantificatSvg"
          >
            <path
              d="M72.1,94.3c-5.9-0.2-10.9,4.4-11.1,10.3c-0.2,5.9,4.4,10.9,10.3,11.1c0.3,0,0.5,0,0.8,0c5.9-0.2,10.6-5.2,10.3-11.1
                C82.3,99,77.7,94.5,72.1,94.3z M168.2,34.3H30.8c-9.2,0.1-16.6,7.7-16.5,16.9c0,0.1,0,0.1,0,0.2v94.3c-0.2,9.2,7.1,16.9,16.3,17.1
                c0.1,0,0.1,0,0.2,0h43.4l-14.5,10.3c-3.4,3.1-3.8,8.3-1,12c2.4,3.6,7.3,4.5,10.9,2.1c0.2-0.1,0.3-0.2,0.4-0.3L100,165l28.9,21.9
                c3.4,2.7,8.3,2.1,11-1.3c0.1-0.1,0.2-0.3,0.3-0.4c2.8-3.7,2.4-8.9-1-12l-14.5-10.3h43.4c9.5,0,17.3-7.6,17.6-17.1V51.4
                C185.4,41.9,177.7,34.3,168.2,34.3L168.2,34.3z M72.1,128.6c-13,0.5-23.9-9.7-24.4-22.7c-0.5-13,9.7-23.9,22.7-24.4
                s23.9,9.7,24.4,22.7c0,0.3,0,0.5,0,0.8C94.9,117.7,84.8,128.2,72.1,128.6L72.1,128.6z M124.8,120c0.3,4.4-3.1,8.3-7.5,8.6
                c-0.2,0-0.5,0-0.7,0c-4.6-0.2-8.2-4-8.3-8.6V98.5c0-4.6,3.7-8.4,8.3-8.6c4.4-0.1,8.2,3.4,8.3,7.8c0,0.2,0,0.5,0,0.7V120L124.8,120z
                M150.6,120c0,4.6-3.7,8.3-8.3,8.3s-8.3-3.7-8.3-8.3V77.1c0-4.6,3.7-8.3,8.3-8.3s8.3,3.7,8.3,8.3V120z"
              fill="#96817b"
            />
          </svg>
          <span class="quantificatText1">量化投资赛道</span>
        </div>
      </div> -->
    </div>
    <!-- 内容区域 -->
    <div class="content">
      <!-- tab栏区域 -->
      <div class="listBtn list" v-show="showSecurityBtn">
        <ul>
          <li
            v-for="(item, index) in list"
            :key="index"
            @click="changeTab(index)"
            :class="activeIndex == index ? 'active' : ''"
            class="tabItem"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <!-- <div class="listBtn1 list" v-show="!showQuantificatBtn">
        <ul>
          <li
            v-for="(item, index) in list"
            :key="index"
            @click="changeTab1(index)"
            :class="activeIndex1 == index ? 'active1' : ''"
            class="tabItem tabItem1"
          >
            {{ item }}
          </li>
        </ul>
      </div> -->
      <!-- tab点击显示的图片区域 -->
      <div class="contentImg">
        <img src="./../assets/img-mobile/contentImg.png" alt="" v-show="showSecurityBtn && activeIndex == 0">
        <img src="./../assets/img-mobile/explain.png" alt="" v-show="showSecurityBtn && activeIndex == 1">
        <img src="./../assets/img-mobile/rules.png" alt="" v-show="showSecurityBtn && activeIndex == 2">
        <img src="./../assets/img-mobile/award.png" alt="" v-show="showSecurityBtn && activeIndex == 3">
        <img src="./../assets/img-mobile/guide.png" alt="" v-show="showSecurityBtn && activeIndex == 4">
        <!-- <img src="./../assets/img-pc/contentImg1.png" alt="" v-show="!showQuantificatBtn && activeIndex1 == 0">
        <img src="./../assets/img-pc/explain1.png" alt="" v-show="!showQuantificatBtn && activeIndex1 == 1">
        <img src="./../assets/img-pc/rules1.png" alt="" v-show="!showQuantificatBtn && activeIndex1 == 2">
        <img src="./../assets/img-pc/award1.png" alt="" v-show="!showQuantificatBtn && activeIndex1 == 3">
        <img src="./../assets/img-pc/guide1.png" alt="" v-show="!showQuantificatBtn && activeIndex1 == 4"> -->
      </div>
    </div>
    <!-- 底部区域 -->
    <div class="bottom" v-show="showSecurityBtn">
        <img src="./../assets/img-pc/qrCode.png" alt="">
        <p class="text">大赛QQ交流群</p>
        <p class="text text1">群号：714861740</p>
      </div>
      <!-- <div class="bottom" v-show="!showQuantificatBtn">
        <img src="./../assets/img-pc/qrCode1.png" alt="">
        <p class="text">量化投资赛道QQ交流群</p>
        <p class="text text1">群号：570292814</p>
      </div> -->
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    return {
      list: [
        "希施玛特色产品服务",
        "大赛简介",
        "赛事规则",
        "权益奖励",
        "报名指引",
      ], // tab列表
      activeIndex: 0, // 点击证券投资tab下标
      // activeIndex1: 0, // 点击量化投资tab下标
      showSecurityBtn: true, // 是否展示点击的证券投资按钮
      // showQuantificatBtn: true, // 是否展示点击的量化投资按钮
    };
  },
  methods: {
    // 是否展示点击的证券投资按钮
    showSecurityImg() {
      this.showSecurityBtn = true;
      this.showQuantificatBtn = true;
      this.activeIndex = 0;
      this.activeIndex1 = 0;
    },
    // 是否展示点击的量化投资按钮
    // showQuantificatImg() {
    //     this.showSecurityBtn = false
    //     this.showQuantificatBtn = false
    //     this.activeIndex = 0
    //     this.activeIndex1 = 0
    // },
    // 证券投资tab切换点击事件
    changeTab(index) {
      this.activeIndex = index;
    },
    // 量化投资tab切换点击事件
    // changeTab1(index) {
    //   this.activeIndex1 = index;
    // },
  },
};
</script>

<style lang="less" scoped>
@import url("./../style/m-reset.css");
.csmar-page {
  ::-webkit-scrollbar {
    display: none;
  }
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  .banner {
    background-color: #fff;
    position: relative;
    // height: 7.25rem;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
    }
    .btnOptions {
      position: absolute;
      bottom: -0.4rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
      .btn {
        width: 4.5rem;
        height: 0.9rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .securitySvg {
          margin-right: 0.1rem;
        }
        .quantificatSvg {
          margin-right: 0.1rem;
        }
      }
      .securityBtn {
        margin-bottom: .1rem;
        background: url("./../assets/img-mobile/securityBtn.png");
        background-size: 100% 100%;
        .securityText {
          color: #d86327;
          font-size: 0.3rem;
          font-weight: bold;
        }
      }
      .securityBtn1 {
        margin-bottom: 0.02rem;
        background: url("./../assets/img-mobile/securityBtn.png");
        background-size: 100% 100%;
        .securityText1 {
          color: #8b7f6f;
          font-size: 0.3rem;
          font-weight: bold;
        }
      }
      .quantificatBtn {
        background: url("./../assets/img-mobile/quantificatBtn1.png");
        background-size: 100% 100%;
        .quantificatText {
          color: #e55240;
          font-size: 0.3rem;
          font-weight: bold;
        }
      }
      .quantificatBtn1 {
        background: url("./../assets/img-mobile/quantificatBtn1.png");
        background-size: 100% 100%;
        .quantificatText1 {
          color: #96817b;
          font-size: 0.3rem;
          font-weight: bold;
        }
      }
    }
  }
  .content {
    width: 100%;
    flex: 1;
    background: url("./../assets/img-pc/background.png") no-repeat;
    background-size: 100% 100%;
    .list {
      width: 100%;
      margin: 0.4rem auto 0.5rem;
      ul {
        width: 100%;
        padding: 0 0.3rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        li {
          font-size: 0.26rem;
          height: 0.66rem;
          display: flex;
          color: #3D3A36;
          align-items: center;
          justify-content: center;
          margin: 0.2rem 0.15rem 0;
          padding: 0.08rem 0.38rem;
          border-radius: 0.38rem;
          .tabItem {
            width: 100%;
            height: 100%;
          }
          &:first-child {
            margin-left: 0.6rem;
          }
          &:nth-child(2) {
            margin-right: 0.6rem;
          }
        }
      }
    }
    .listBtn {
      li {
        background: #FEE8BE;
        border: 0.01rem solid #E2C49A;
      }
    }
    .listBtn1 {
      li {
        background: #F27C58;
      }
    }
    .contentImg {
      width: 100%;
      padding: 0 .3rem;
      margin: 0 auto .5rem;
      img {
        width: 100%;
        background-size: 100% 100%;
      }
      .guideText {
        font-size: .12rem;
        line-height: .4rem;
        // -webkit-transform:scale(0.9);
        // -moz-transform:scale(0.9);
        // -o-transform:scale(0.9);
        // -ms-transform:scale(0.9);
        // transform:scale(0.9);
        color: #D86327;
      }
    }
  }
  .bottom {
        width: 100%;
        height: 3rem;
        background-color: #302419;
        img {
          width: 1.4rem;
          height: 1.4rem;
          display: block;
          margin: .26rem auto 0;
        }
        .text {
          font-size: .12rem;
          // -webkit-transform:scale(0.9);
          // -moz-transform:scale(0.9);
          // -o-transform:scale(0.9);
          // -ms-transform:scale(0.9);
          // transform:scale(0.9);
          color: #D7D7D7;
          margin-top: .1rem;
          text-align: center;
        }
        .text1 {
          margin-bottom: .26rem;
        }
    }
  .active {
    background: #D96327 !important;
    color: #ffffff !important;
    border: 0.01rem solid #fff !important;
  }
  .active1 {
    background: #E04636 !important;
    color: #ffffff !important;
    border: 0.01rem solid #fff !important;
  }
}
</style>